import { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../translations';

const STORAGE_KEY = 'padelarena.language';
const SUPPORTED = ['de', 'en', 'fr', 'it', 'es'];
const DEFAULT_LANG = 'de';

const readInitial = () => {
  if (typeof window === 'undefined') return DEFAULT_LANG;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED.includes(stored)) return stored;
  // Fall back to browser locale if it's one we support (first-time visits).
  const nav = (window.navigator.language || '').slice(0, 2).toLowerCase();
  if (SUPPORTED.includes(nav)) return nav;
  return DEFAULT_LANG;
};

export const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(readInitial);

  const setLanguage = (next) => {
    if (!SUPPORTED.includes(next)) return;
    setLanguageState(next);
  };

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, language);
      document.documentElement.lang = language;
    } catch { /* ignore quota / SSR errors */ }
  }, [language]);

  const t = translations[language] || translations[DEFAULT_LANG];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
